import { Component, Inject, OnInit } from "@angular/core";
import { CommonModule } from "@angular/common";
import { OKTA_AUTH } from "@okta/okta-angular";
import { OktaAuth } from "@okta/okta-auth-js";
import { WebLogger } from "@weps/shared-http";

@Component({
  selector: "app-okta-callback",
  template: `<p *ngIf="error">{{ error }}</p>`,
  standalone: true,
  imports: [CommonModule],
})
export class OktaCallbackComponent implements OnInit {
  private static readonly RETRY_KEY = "weps_okta_callback_retries";
  private static readonly MAX_RETRIES = 1;
  error?: string;

  constructor(@Inject(OKTA_AUTH) private oktaAuth: OktaAuth) {}

  async ngOnInit(): Promise<void> {
    try {
      await this.oktaAuth.handleLoginRedirect();
      sessionStorage.removeItem(OktaCallbackComponent.RETRY_KEY);
    } catch (e: any) {
      const message = e?.message || e?.toString();
      WebLogger.log({
        message: `Okta callback failed: ${message}`,
        level: "error",
      });

      const retries = parseInt(sessionStorage.getItem(OktaCallbackComponent.RETRY_KEY) || "0", 10);
      if (retries < OktaCallbackComponent.MAX_RETRIES) {
        sessionStorage.setItem(OktaCallbackComponent.RETRY_KEY, String(retries + 1));
        WebLogger.log({
          message: `Okta callback: retrying SSO flow (attempt ${retries + 1}/${OktaCallbackComponent.MAX_RETRIES})`,
          level: "warn",
        });
        await this.oktaAuth.signInWithRedirect({ originalUri: "/personal-wealth-inventory" });
      } else {
        sessionStorage.removeItem(OktaCallbackComponent.RETRY_KEY);
        this.error = "Authentication failed. Please close this tab and try again.";
      }
    }
  }
}
